// extracted by mini-css-extract-plugin
export default {"label":"IconTabButton_label__FeDzR","tab":"IconTabButton_tab__n13oZ","tabActive":"IconTabButton_tabActive__vW5O3"};